import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Search, Menu, X } from 'lucide-react';
import ImageSlider from './ImageSlider';
import VideoPlayer from './Video-player';
import { Facebook, Instagram, Twitter, Youtube } from 'lucide-react';

const SocialIcon = ({ Icon, href, label }) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    className="text-white hover:text-yellow-500 transition-colors p-2"
    aria-label={label}
  >
    <Icon size={24} />
  </a>
);
const fontStyles = `
  @import url('https://fonts.cdnfonts.com/css/trajan-pro');

  body {
    font-family: "Trajan Pro", serif !important;
    font-weight: bold;
  }

  /* Reset font for specific elements if needed */
  .default-font {
    font-family: system-ui, -apple-system, sans-serif !important;
  }
`;
const Alert = ({ type, message, onClose }) => {
  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => {
        onClose();
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [message, onClose]);

  if (!message) return null;

  return (
    <div
      className={`p-4 rounded ${type === 'success' ? 'bg-green-900' : 'bg-red-900'} text-white`}
    >
      {message}
    </div>
  );
};

const Website = () => {
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState({ type: '', message: '' });
  const videoUrl = "https://www.youtube.com/watch?v=5FQYwKq-VaE";
  const apiUrl = process.env.REACT_APP_NODE_API;
  const messageTimeoutRef = useRef(null);

  const [websiteContent, setWebsiteContent] = useState(null);

  useEffect(() => {
    const fetchContentFromS3 = async () => {
      try {
        const timestamp = new Date().getTime();
        const response = await fetch(`${process.env.REACT_APP_WEBSITE_CONTENT_URL}?v=${timestamp}`);

        const text = await response.text();

        // Evaluate the JavaScript file content and extract JSON data
        const jsonData = eval(text.replace(/^const websiteContent = /, '').replace(/;$/, ''));

        setWebsiteContent(jsonData);
      } catch (error) {
        console.error("Failed to fetch content:", error);
      }
    };

    fetchContentFromS3();
  }, []);


  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    // Clear any existing timeout
    if (messageTimeoutRef.current) {
      clearTimeout(messageTimeoutRef.current);
    }

    try {
      const dbResponse = await fetch(`${apiUrl}api/subscribe`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      const data = await dbResponse.json();

      if (!dbResponse.ok) {
        throw new Error(data.message || data.error || 'Failed to subscribe. Please try again later.');
      }

      setSubmitStatus({
        type: 'success',
        message: data.message || 'Successfully subscribed to newsletter!'
      });
      setEmail('');

    } catch (error) {
      let errorMessage = 'An error occurred. Please try again later.';

      if (error.message === 'Failed to fetch') {
        errorMessage = 'Unable to connect to server. Please check your internet connection.';
      } else if (error.message.includes('Email already subscribed')) {
        errorMessage = 'This email is already subscribed.';
      } else if (error.message.includes('Invalid email')) {
        errorMessage = 'Please enter a valid email address.';
      } else {
        errorMessage = error.message;
      }

      setSubmitStatus({
        type: 'error',
        message: errorMessage
      });
    } finally {
      setIsSubmitting(false);

      // Set a timeout to clear the message after 5 seconds
      messageTimeoutRef.current = setTimeout(() => {
        setSubmitStatus({ type: '', message: '' });  // Set to empty object instead of null
      }, 5000);
    }
  };


  useEffect(() => {
    return () => {
      if (messageTimeoutRef.current) {
        clearTimeout(messageTimeoutRef.current);
      }
    };
  }, []);


  return (
    <>
      <style>{fontStyles}</style>
      <div id="header" className="fixed top-0 w-full bg-black">
        <div className="container mx-auto px-4 flex justify-between items-center">
          <div className="icons">
            <button
              className="w-navpane-trigger cursor-pointer p-4"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              {isMenuOpen ? (
                <X className="h-6 w-6 text-white" />
              ) : (
                <Menu className="h-6 w-6 text-white" />
              )}
            </button>
          </div>

          <div className="logo">
            <span className="wsite-logo">
              <span className="wsite-title-placeholder">&nbsp;</span>
              <span className="hidden ">Game of Divine - The Spiritual Board Game</span>
            </span>
          </div>

          <div className="icons flex items-center">
            <button
              className="wsite-search-button p-2"
              onClick={() => setIsSearchOpen(!isSearchOpen)}
            >
              <Search className="w-5 h-5 text-white" />
            </button>
          </div>
        </div>

        {/* Navigation Menu */}
        <div className={`navlist w-navlist nav ${isMenuOpen ? 'block' : 'hidden'} bg-black border-t border-gray-800`}>
          <ul className="wsite-menu-default">
            <li className="wsite-menu-item-wrap">
              <a href="/" className="wsite-menu-item text-white hover:text-gray-300 block px-4 py-2">
                Home
              </a>
            </li>

          </ul>
        </div>

        {/* Search Panel */}
        <div className={`slide-panel ${isSearchOpen ? 'block' : 'hidden'} bg-black border-t border-gray-800`}>
          <div className="container mx-auto px-4 py-4">
            <p className="text-white mb-4 ">Search by typing & pressing enter</p>
            <form id="wsite-header-search-form" action="/apps/search" method="get" className="relative">
              <input
                type="text"
                name="q"
                className="wsite-search-input w-full p-2 bg-white"
                autoComplete="off"
                placeholder="Search"
              />
              <button type="submit" className="wsite-search-button absolute right-2 top-2">
                <Search className="w-5 h-5" />
              </button>
            </form>
          </div>
        </div>
      </div>
      <div className="bg-black text-white">
        <div id="banner" className="pt-16">
          <div className="container mx-auto px-4">
            <div className="text-center">
              <img
                src="https://itihasgames.com/media/god.png"
                alt="Game of Divine Logo"
                className="mx-auto max-w-full w-auto "
              />

            </div>
          </div>
        </div>

        <div id="main" className="py-2">
          {websiteContent?.map((contentItem, index) => (
            <div key={index} className="container mx-auto px-4">
              <div className="text-center">
                {contentItem.title && (
                  <h2 className="text-4xl font-bold mb-8">{contentItem.title}</h2>
                )}
                {contentItem.description && (
                  <h3 className="text-2xl font-bold mb-4">
                    {contentItem.description}
                  </h3>
                )}


                {contentItem.image_url && !contentItem.video_url && (
                  <img src={contentItem.image_url} alt={contentItem.title} className="mx-auto max-w-full w-auto pb-1 pt-1" />
                )}
                {contentItem.slider_images && (
                  <div className="video-container mb-8">
                    <ImageSlider images={contentItem.slider_images} />
                  </div>
                )}
                {contentItem.video_url && (
                  <div className="video-container mb-8">
                    <VideoPlayer videoUrl={contentItem.video_url}
                      thumbnailUrl={contentItem.image_url} />

                  </div>
                )}


              </div>
            </div>
          ))}
          <div className="container mx-auto px-4">
            <div className="text-center">

              <div className="gameplay-sections ">

                <div className="bg-black text-white py-1">
                  <div className="container mx-auto px-4 max-w-4xl">
                    <h2 className="text-2xl font-bold text-center mb-8">COMING SOON</h2>

                    <img
                      src="https://itihasgames.com/media/itihas-logo-new-2.png?1737707855"
                      alt="Itihas Games Logo"
                      className="mx-auto w-32 mb-8"
                    />

                    <div className="max-w-xl mx-auto">
                      <form onSubmit={handleSubmit} className="space-y-6">
                        <h3 className="text-xl italic text-center mb-8">
                          Be the first to experience Game of Divine! Drop your email Id to receive exclusive offers, early access, and preorder updates.
                        </h3>

                        <div className="space-y-2">
                          <div className="flex items-start mb-1">
                            <label htmlFor="email" className="text-sm">
                              Email <span className="text-red-500">*</span>
                            </label>
                          </div>
                          <small className="text-gray-400 block mb-2">
                            <span className="text-red-500">*</span> Indicates required field
                          </small>

                          <input
                            type="email"
                            id="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            className="w-full px-4 py-2 bg-gray-900 border border-gray-700 rounded focus:outline-none focus:border-gold-500"
                            aria-required="true"
                          />

                        </div>

                        {submitStatus.message && (
                          <div
                            className={`fixed top-4 right-4 p-4 rounded-md shadow-lg ${submitStatus.type === 'success'
                              ? 'bg-green-600 text-white'
                              : 'bg-red-600 text-white'
                              }`}
                            style={{ zIndex: 1000 }}
                          >
                            {submitStatus.message}
                          </div>
                        )}

                        <div className=" mt-6">
                          <button
                            type="submit"
                            disabled={isSubmitting}
                            className="bg-gray-500 text-black px-6 py-2 rounded hover:bg-yellow-600 transition disabled:opacity-50"
                          >
                            {isSubmitting ? "You're all set! We'll send you updates on pre-orders shortly." : 'Pre-Order'}
                          </button>
                        </div>
                      </form>
                      <div className="mt-12 flex flex-col justify-center space-x-6">
                        <div>
                          <h3 className="text-xl  text-center mb-8">
                            Stay connected! Follow us on social media for the latest updates and exclusive insights!
                          </h3>
                        </div>
                        <div className='mt-2 flex justify-center space-x-6'>
                          <SocialIcon
                            Icon={Facebook}
                            href="https://www.facebook.com/ItihasGames/"
                            label="Facebook"
                          />
                          <SocialIcon
                            Icon={Instagram}
                            href="https://www.instagram.com/gameofdivineofficial/"
                            label="Instagram"
                          />
                          <SocialIcon
                            Icon={Twitter}
                            href="https://x.com/gameofdivine"
                            label="Twitter"
                          />
                          <SocialIcon
                            Icon={Youtube}
                            href="https://www.youtube.com/@ItihasGames"
                            label="YouTube"
                          />
                        </div>


                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>

      </div>
    </>
  );
};

export default Website;